import { ProductThumbnail } from 'lib/hooks/use-products'
import Thumbnail from 'components/product/Thumbnail'

type Props = {
	title?: string
	products: ProductThumbnail[]
}

export default function Products({ title, products }: Props ) {
	return (
		<section className="cf">
			{( !!title && <h2>{title}</h2> )}
			<div className="scroller cf-negative">
				<div
					className={(
						( products.length === 2 ? 'two ' : '' ) +
					( products.length >= 4 ? 'four ' : '' ) +
					'products'
					)}
				>
					{products.slice( 0, 4 ).map( product => (
						<Thumbnail key={product.handle} product={product} quickAdd />
					) )}
				</div>
			</div>
			<style jsx>{`
				.products {
					display: grid;
					grid-auto-flow: column;
					grid-template-columns: repeat( auto-fit, minmax( 250px, 1fr ) );
					grid-column-gap: 36px;
					grid-row-gap: 70px;
				}
				.products :global( picture ) {
					height: 400px;
					padding: 80px 0;
				}
				@media ( max-width: 1200px ) {
					.scroller {
						overflow-x: auto;
						scroll-snap-type: x mandatory;
					}
					.products {
						display: flex;
						padding-bottom: 15px;
					}
					.products > :global(*) {
						flex: 0 0 min(300px, 75vw);
						scroll-snap-align: start;
					}
					.products::after {
						content: ".";
						color: transparent;
					}
				}
				@media ( max-width: 500px ) {
					.products {
						grid-row-gap: 48px;
					}
					.products :global( picture ) {
						height: min(400px, 100vw);
						padding: 30% 0;
					}
				}
				@media ( min-width: 501px ) and ( max-width: 900px ) {
					.products :global( picture ) {
						height: max(400px, 60vw);
						padding: 30% 0;
					}
				}
			`}</style>
		</section>
	)
}

